function delete_attachment(attachment_id){
	if(confirm(get_language_translation('LANG_ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ATTACHMENT'))){
		var attachment_div = $('attachment_'+attachment_id);
		attachment_div.addClassName('line-through');
		attachment_div.addClassName('loading');
		var url = 'attachments/delete/';
		new Ajax.Request(url, {
			parameters: {
				attachment_id: attachment_id
			},
			onSuccess: function(transport) {
				attachment_div.update(transport.responseText);
				attachment_div.removeClassName('loading');
				attachment_div.removeClassName('line-through');
				attachment_div.addClassName('deleted');
				attachment_div.highlight({ queue: 'end', duration: 1.5, endcolor: hlcolor(attachment_div) }).blindUp({
					queue: 'end',
					duration: 1.5,
					afterFinish: function(){
						declare_empty_att_box(attachment_div);
					}
				});
			},
			onFailure: function(transport) {
				add_notification(get_language_translation('LANG_MSG_ERROR_DELETING_ATTACHMENT_YOU_MAY_NOT_BE_AUTHORIZED_TO_DELETE_THAT_ATTACHMENT'), 'danger');
				el.removeClassName('line-through');
				el.removeClassName('loading');
			}
		});
	}
	return false;
}
function delete_attachment_b2b(instance, attachment_id)
{
	open_modal('<div class="notice">This attachment was created at ' + instance + '.allmoxy.com.&nbsp; As such, it must be deleted directly on that server.</div>',
	{
		title: 'Delete Attachment',
		ok: true
	});
}
// This function is presently not used; attachment editing has been either partially removed or never completed.
function update_attachment(attachment_id){
	var attachment_div = $('attachment_'+attachment_id);
	attachment_div.addClassName('loading');
	var url = 'attachments/edit/'+attachment_id+'/';
		new Ajax.Request(url, {
			parameters: {
				attachment_id: attachment_id,
				visibility: attachment_div.down('select').value,
				belongs_to: $('attachment_' + attachment_id + '_belongs_to').value
			},
			onSuccess: function(transport) {
				attachment_div.replace(transport.responseText);
				//$('attachment_'+attachment_id).highlight();  //if we want it to highlight to show that it was edited.
			},
			onFailure: function(transport) {
				add_notification(get_language_translation('LANG_MSG_ERROR_UPDATING_ATTACHMENT_YOU_MAY_NOT_BE_AUTHORIZED_TO_UPDATE_THAT_ATTACHMENT'), 'danger');
				attachment_div.removeClassName('loading');
			}
		});
	return false;
}

function process_file_upload(){
	if($('file').value.length>0){
		$('new_attachment_form').submit();
		$('new_attachment_form').disable();
		$('new_attachment_form').down('div.attachment').addClassName('loading');
	}
}

function after_upload(response){
	if(response.success){
		$('file').value='';
		$('new_attachment_form').enable();
		$('new_attachment_form').down('div.attachment').removeClassName('loading');
		new Ajax.Updater('att_box', 'attachments/' + response.attachment_id +'/&belongs_to=' + response.belongs_to, {
			insertion: 'bottom',
			method: 'get',
			onComplete: function()
			{
				$('attachment_' + response.attachment_id).highlight({ endcolor: hlcolor($('attachments')) });
			}
		});
		$('attachments').show();
	}
	else{
		formfielname = document.getElementById('file').files[0].name;
		add_notification(get_language_translation('LANG_MSG_UNABLE_TO_UPLOAD_FILE') + ' ' + formfielname + ': ' + response.error_message, 'danger');
		$('file').value = '';
		$('new_attachment_form').enable();
		$('new_attachment_form').down('div.attachment').removeClassName('loading');
	}
}

function declare_empty_att_box(el)
{
	el.remove();
	if(!$('att_box').children.length && !$('new_attachment_form'))
		$('att_box').insert('<div>There are no more attachments.</div>');
}
function add_attachment_button_event() {
	$$('input.file').each(function(el) {
		var label	 = el.up().down('.att_name');
		if (label) {
			var labelVal = label.innerHTML;
	
			el.observe( 'change', function( e )
			{
				var fileName = '';
				if( this.files && this.files.length > 1 )
					fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
				else
					fileName = e.target.value.split( '\\' ).pop();
	
				if( fileName )
					label.innerHTML = fileName;
				else
					label.innerHTML = labelVal;
			});
		}
	});
}